/**
 * @name RootComponent
 * @author Gabriel M. Guimarães | gabrielmg7
 * @description Componente raiz que organiza a estrutura da aplicação com fundo gradiente
 * @returns {JSX.Element} - O JSX do componente raiz
 * @package src/RootComponent.tsx
 */

import { CssBaseline } from "@mui/material";
import React from "react";

import App from "./App";
import GradientBackground from "./components/common/backgrounds/GradientBackground";
import { AlertProvider, AlertSnackbar } from "./contexts/AlertContext";
import { LoadingProvider } from "./contexts/LoadingContext";

const RootComponent: React.FC = () => {
  return (
    <AlertProvider>
      <LoadingProvider>
        <GradientBackground>
          <CssBaseline />
          <App />
          <AlertSnackbar />
        </GradientBackground>
      </LoadingProvider>
    </AlertProvider>
  );
};

export default RootComponent;
